import { SortKey } from '../../../../utils/tableHelper';

export const rlrsReportColumns = {
  rlrCreatedDate: {
    label: 'RA date',
    canBeSorted: true,
    sortKey: SortKey.RLR_CREATED_AT,
    tooltip: 'The time when Cymbio received the return authorization from the retailer',
    isDefault: true,
    isDate: true,
  },
  rlrIdInSource: {
    label: 'RA number',
    isDefault: true,
    canBeSorted: true,
    tooltip: 'The retailer`s return authorization ID',
  },
  orderCreatedDate: {
    label: 'Order created date',
    canBeSorted: true,
    sortKey: SortKey.ORDER_CREATED_AT,
    isDate: true,
    isDefault: true,
  },
  salesChannel: {
    label: 'Sales channel',
    isDefault: true,
  },
  country: {
    label: 'Country',
    isDefault: true,
  },
  retailerOrderId: {
    label: 'Retailer order id',
    canBeSorted: true,
    isDefault: true,
  },
  rlrWasProcessed: {
    label: 'Open',
    isDefault: true,
    tooltip: 'The status indicates if a full refund was issued to the retailer',
  },
  salesOrderNumber: {
    label: 'Sales order id',
    canBeHidden: true,
    isDefault: true,
  },
  sku: {
    label: 'SKU',
    canBeHidden: true,
    isDefault: true,
  },
  upc: {
    label: 'UPC',
    canBeHidden: true,
    isDefault: true,
  },
  ean: {
    label: 'EAN',
    canBeHidden: true,
    isDefault: true,
  },
  model: { label: 'Model', canBeHidden: true, isDefault: true, canBeSorted: true, sortKey: SortKey.MODEL },
  productName: {
    label: 'Product name',
    canBeHidden: true,
    isDefault: true,
    canBeSorted: true,
  },
  rlrUnits: {
    label: 'Returned units',
    canBeHidden: true,
    canBeSorted: true,
    isDefault: true,
  },
  fulfillmentId: {
    label: 'Fulfillment Id',
    canBeHidden: true,
    isDefault: true,
  },
  fulfillmentIdInSource: {
    label: 'Fulfillment Id In Source',
    canBeHidden: true,
    isDefault: true,
  },
  rlrTrackingNumber: {
    label: 'Tracking Information',
    canBeHidden: true,
    isDefault: true,
  },
  rlrReasonType: {
    label: 'Reason Type',
    canBeHidden: true,
    isDefault: true,
  },
  rlrReasonText: {
    label: 'Reason Text',
    canBeHidden: true,
    isDefault: true,
  },
};
